// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorView_container_2riHC","icon":"ErrorView_icon_22kv0","message":"ErrorView_message_3IG13"};